import { RootState } from '../../reducers'

export const baseVariableListTypeSelector = (state: RootState) =>
  state.ui.bottomPanelBaseVariable.baseVariableList
